const SPLIT_DOT_COLOR = '#BF8200'
const DEFAULT_POINT_COLOR = 'rgb(75, 192, 192)'
const DEFAULT_RADIUS = 1
const HOVER_RADIUS = 5

function isInRange(splitTime: number, labels: string[]): boolean {
  const firstDate = new Date(labels[0]).getTime()
  const lastDate = new Date(labels[labels.length - 1]).getTime()
  return splitTime >= firstDate && splitTime <= lastDate
}

export interface InsertSplitResult {
  labels: string[]
  datasets: any[]
  splitIndex: number
}

export function insertSplitDataPoint(
  labels: string[],
  datasets: any[],
  splitDate: string | null,
  splitPrice: number | null,
): InsertSplitResult {
  if (!splitDate || !labels?.length) {
    return { labels, datasets, splitIndex: -1 }
  }

  const splitTime = new Date(splitDate).getTime()

  if (!isInRange(splitTime, labels)) {
    return { labels, datasets, splitIndex: -1 }
  }

  const exactIndex = labels.findIndex(
    (label) => new Date(label).getTime() === splitTime,
  )

  if (exactIndex !== -1) {
    return { labels, datasets, splitIndex: exactIndex }
  }

  const insertIndex = labels.findIndex(
    (label) => new Date(label).getTime() > splitTime,
  )

  const updatedLabels = [...labels]
  updatedLabels.splice(insertIndex, 0, splitDate)

  const updatedDatasets = datasets.map((dataset) => {
    const data = [...(dataset.data as (number | null)[])]
    data.splice(insertIndex, 0, splitPrice ?? null)
    return { ...dataset, data }
  })

  return {
    labels: updatedLabels,
    datasets: updatedDatasets,
    splitIndex: insertIndex,
  }
}

export function buildPointStyles(dataLength: number, splitIndex: number) {
  const pointBackgroundColor = Array(dataLength).fill(DEFAULT_POINT_COLOR)
  const pointBorderColor = Array(dataLength).fill(DEFAULT_POINT_COLOR)
  const pointRadius = Array(dataLength).fill(DEFAULT_RADIUS)
  const pointHoverBackgroundColor = Array(dataLength).fill(DEFAULT_POINT_COLOR)
  const pointHoverRadius = Array(dataLength).fill(HOVER_RADIUS)

  if (splitIndex >= 0 && splitIndex < dataLength) {
    pointBackgroundColor[splitIndex] = SPLIT_DOT_COLOR
    pointBorderColor[splitIndex] = SPLIT_DOT_COLOR
    pointRadius[splitIndex] = HOVER_RADIUS
    pointHoverBackgroundColor[splitIndex] = SPLIT_DOT_COLOR
  }

  return {
    pointBackgroundColor,
    pointBorderColor,
    pointRadius,
    pointHoverBackgroundColor,
    pointHoverRadius,
  }
}
